const resolveNonNegativeInteger = (value: string): number | undefined => {
  if (value.trim() === '') {
    return undefined;
  }

  const parsedValue = Number(value);

  return Number.isInteger(parsedValue) && parsedValue >= 0
    ? parsedValue
    : undefined;
};

export default resolveNonNegativeInteger;
